import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment-timezone';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { AppConstant, DateFormat } from 'src/app/core/constants/app.constant';
import { AccountService } from 'src/app/core/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { PreferenceService } from 'src/app/core/services/preference.service';
import { PrincipalService } from 'src/app/core/services/principal.service';
import { HomeService } from 'src/app/modules/home/home.service';
import { IResponse } from 'src/app/shared/models/app';
import { RouteUtilService } from 'src/app/shared/utils/route-util.service';
import { DayboardDateService } from '../dayboard-date.service';
import { EodReportComponent } from './eod-report/eod-report.component';
import { RejectedRequestComponent } from './rejected-request/rejected-request.component';
import { SelectMobileDialogComponent } from './select-mobile-dialog/select-mobile-dialog.component';
import { faAngleDown, faAngleUp, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ManufacturerOrderPopupComponent } from './manufacturer-order-popup/manufacturer-order-popup.component';
import { ApplicationAlertComponent } from './application-alert/application-alert.component';
import { SelectAddressDialogComponent } from './select-address-dialog/select-address-dialog.component';
import { TokenService } from 'src/app/core/services/token.service';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { AssayDoseRoutes } from 'src/app/core/constants/route.constant';


@Component({
    selector: 'nuctrac-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  /*********************Properties*********************/
  selectedAccount: any;
  selectedMobile: any;
  mobileList: any;
  accountList: any;
  user: any;
  hideHeader: boolean = false;
  showMobilePanel: boolean = false;
  loggedInUser: string;
  defaultShipTo: any;
  currentTime: string;
  currentDate: any;
  dayBoardDate: any;
  showToday: boolean = false;
  showClock: boolean = true;
  nuctracEssential: boolean;
  showMobile: boolean = false;
  clockInterval: any;
  changedDate: any;
  deliveryAddressList: any;
  selectedAddress: any;
  showDeliveryAddress: boolean = false;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faExclamationCircle = faExclamationCircle;
  private subscription = {
    dateChanged: null,
    refreshBtn: null,
    reservationsData:null,
    showClock:null,
    rejectedCount:null,
    session: { expiring: null, expired: null },
    rejectionNotificationData:null,
    setDayboardDate: null,
    dashboardView: null
  };
  inventories: any = {};
  readonly session = { expiring: false, warning: true, timeRemaining: null, refreshed: false };
  showNewRejectNotification:boolean = false;
  rejectedCount: number = 0;
  rejectionNotificationData:any = null;
  manufacturerOrderPref :boolean = false;

  @Output() headerHidden = new EventEmitter();
  @Output() mobileHeaderHidden = new EventEmitter();
  @Output() isMobile = new EventEmitter();
  isMobTab = false;
  refreshBtn: any = true;
  manufacturerOrderCount: number = 0;
  loginUrl: any;
  appMaintenanceObj: any={};
  isReleaseNoteAvailable: boolean;
  showHeaderClockFlag: any=false;
  permission: any;
  disableControl: boolean;
  type: string = 'dayboard';
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private storage: SessionStorageService,
    private accountService: AccountService,
    private principal: PrincipalService,
    private authService: AuthService,
    public dialog: MatDialog,
    private token: TokenService,
    private preferenceService: PreferenceService,
    private dayBoardDateService: DayboardDateService,
    private homeService: HomeService,
    private router: RouteUtilService,
    private breakpointObserver: BreakpointObserver,
    private cache: CacheResolverService,
    private appService: AppService,
    private routerObject: Router
  ) { }    
  /*********************Constructor*********************/

  /*********************Lifecyle Methods*********************/
  ngOnInit() {
    this.subscription.reservationsData = this.homeService.reservations$.subscribe(value => {      
      this.manufacturerOrderCountSubs(value);
    })
    this.subscription.showClock = this.preferenceService.preferences$.subscribe(value=>{
      this.showHeaderClockFlag = this.preferenceService.getPreference(AppConstant.Preferences.SYSTEM_TIMEZONE).value;
    })
    this.subscription.rejectedCount =  this.homeService.rejectedCount$.subscribe(value=>{
      this.rejectedCount = value;
      if(!this.showNewRejectNotification){
        this.getData(this.currentDate);
      }
    })
    this.subscription.session.expiring =
      this.token.apigee.tokenExpiring$.subscribe((expiring) =>
        this.onApigeeTokenExpiring(expiring)
      );
    this.subscription.session.expired =
      this.token.apigee.tokenExpired$.subscribe((expired) =>
        this.onApigeeTokenExpired(expired)
      );
    this.subscription.rejectionNotificationData =  this.homeService.rejectionNotificationData$.subscribe(value=>{
      this.rejectionNotificationData = value;
    });
    this.getManufacturerOrderPref();
    this.Init();   
    this.breakpointObserver
    .observe([Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait])
      .subscribe((result: BreakpointState) => {
        if (result.matches) {
          this.isMobTab = true;
        } else {
          this.isMobTab = false;
        }
      });
  }

  private onApigeeTokenExpiring(tokenExpiration: any) {
    this.session.refreshed = false;
    this.session.expiring = tokenExpiration.expiring;

    if (this.session.expiring) {
      if (this.session.warning) {
        this.session.warning = false;
        this.refreshSession();
      }
    } else {
      this.session.timeRemaining = null;
    }
  }

  private refreshSession() {
    this.token.getAccessToken().then((response) => {
      if (response) {
        this.token.renew().subscribe((res)=>{
          this.storage.store(CacheConstant.SessionStorageData.RefreshToken, res['refresh_token']);
          this.storage.store(CacheConstant.SessionStorageData.AccessToken, res['access_token']);
          this.storage.store(CacheConstant.SessionStorageData.IdToken, res['id_token']);
          this.token.validate(res['access_token'], res['id_token']).subscribe((tokenResponse: any) => {
            if (!tokenResponse.hasError) {
              this.appService.load().then(() => {
                setTimeout(() => {
                  this.session.expiring = false;
                  this.session.warning = true;
                  this.session.refreshed = true;
                }, 3000);
              });
            } else {
              this.logOut();
            }
          });
        },
        (error)=>{
          this.logOut();
        }
        )
      }
    });
  }

  private onApigeeTokenExpired(expired: boolean) {
    if (expired) {
      this.authService.logOut();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.clockInterval);
    if (this.subscription?.dateChanged) {
      this.subscription.dateChanged.unsubscribe();
    }
    if (this.subscription?.refreshBtn) {
      this.subscription.refreshBtn.unsubscribe();
    }
    if (this.subscription?.reservationsData) {
      this.subscription.reservationsData.unsubscribe();
    }
    if (this.subscription?.showClock) {
      this.subscription.showClock.unsubscribe();
    }
    if (this.subscription?.rejectedCount) {
      this.subscription.rejectedCount.unsubscribe();
    }
    if (this.subscription?.session?.expiring) {
      this.subscription.session.expiring.unsubscribe();
    }
    if (this.subscription?.session?.expired) {
      this.subscription.session.expired.unsubscribe();
    }
    if (this.subscription?.rejectionNotificationData) {
      this.subscription.rejectionNotificationData.unsubscribe();
    }
    if (this.subscription?.setDayboardDate) {
      this.subscription.setDayboardDate.unsubscribe();
    }
  }
  /**********************Lifecyle Methods*********************/
  private Init() {
    this.refreshBtnShow();
    this.rejectedDateChange();
    this.getAccountDetails();
    this.setClock();
    this.loadPreferences();
    this.showNewRejectNotification = this.homeService.getNewRejectNotificationPreference();
    this.setDashboardChangedDate();
    this.hideDashboardDate();
  }

  showMaintenanceBanner(){
    this.appMaintenanceObj = {};
		this.appMaintenanceObj = this.storage.retrieve(CacheConstant.SessionStorageData.NuctracAppMaintenance);
		if (this.appMaintenanceObj) {
      if(this.appMaintenanceObj && this.appMaintenanceObj.releaseNote === ' ')
        this.isReleaseNoteAvailable = false;
      else
        this.isReleaseNoteAvailable = true;
      }
			if(this.appMaintenanceObj && this.appMaintenanceObj.activeFlag){
				this.dialog.open(ApplicationAlertComponent, {
          width: '500px',
          height: '300px',
          panelClass:'application-alert',
          data: {appMaintenanceObj:this.appMaintenanceObj,isReleaseNoteAvailable:this.isReleaseNoteAvailable},
        }).afterClosed().subscribe(result=>{
          this.selectMobile();
        });
			}
      else{
        this.selectMobile();
      }
  }

  selectMobile(){
    if(!this.showDeliveryAddress && this.selectedAccount.isMobile){
      this.openMobileDialog();
    }
  }
  getManufacturerOrderPref(){
    if (this.preferenceService.getPreference(
            AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
        )
        && this.preferenceService.getPreference(
            AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
       ).value) {

      this.manufacturerOrderPref = this.preferenceService.getPreference(
          AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
      ).value;      
    }
  }

  private manufacturerOrderCountSubs(value) {
    this.getManufacturerOrderPref();
    this.manufacturerOrderCount = value ? value.manufacturerOrderCount : 0;
    const isreservLoaded = this.cache.get(CacheConstant.LocalStorage.reservations);         
    if (value && !isreservLoaded && !this.isMobTab && !this.manufacturerOrderPref) {
      setTimeout(() => {
        if (!value.isMobile && value.manufacturerOrderCount > 0 && this.homeService.isReservationsLoaded() && !this.showDeliveryAddress && !this.showMobile) {
        
          const dialogRef = this.dialog.open(ManufacturerOrderPopupComponent, {
            width: '500px',
            height: '300px',
            panelClass: 'reservations',
            data: {},
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.cache.set(CacheConstant.LocalStorage.reservations, true);
            if (result.data) {
              this.router.navigate('/alerts/manufacturer-order-alerts');
            } else {
              this.router.navigate('/home');
            }
          });
        }
        
      }, 1000)
    }
  }

  private refreshBtnShow() {
    this.subscription.refreshBtn = this.dayBoardDateService.refreshBt$.subscribe(
      (value) => {
        this.refreshBtn = value;
      }
    );
  }
  private rejectedDateChange() {
    this.subscription.dateChanged = this.dayBoardDateService.dateChanged$.subscribe(
      (dashboardDate) => {
        this.homeService._dashboardDate = dashboardDate;
        if(this.showNewRejectNotification){
          this.getRejectNotificationCount();
        }
        else{
          this.getData(dashboardDate);
        }
    });
  }

  getRejectNotificationCount(){
     this.homeService.getRejectedRequestNotification().subscribe((response:IResponse)=> {
        if(!response.hasError && response.data != null){
          this.homeService.rejectionNotificationData$.next(response.data);
          this.homeService.rejectedCount$.next(
            response.data ? response.data.length : 0
          );
        };
     });
  }

  getData(date) {
    if(date !==null && date !== "Invalid date" && date!==undefined){
      this.homeService.getOrder(date).subscribe((response: any) => {
        this.inventories.orderDetails = response.data;
        this.rejectedCount = this.inventories.orderDetails?.RejectedRequestCount;
      });
    }
  }

  /*********************Component Methods*********************/

  setDateTime() {
    this.currentDate = new Date();
    this.currentTime = moment().format(DateFormat.HHMMA);
    this.dayBoardDate = moment().format(DateFormat.MMMMDYYYY);
    this.cache.set('TodayDate',this.currentDate);
  }
  showTodayData() {
    this.setDateTime();
    this.showToday = false;
    this.refresh();
  }
  loadPreferences() {
    this.preferenceService
      .loadPreferences()
      .subscribe((response: IResponse) => {
        var showBot = this.preferenceService.getPreference(54);
        var nucBot = (<HTMLElement>document.querySelector('nucbot-widget'));       
        nucBot.style.display = (showBot && showBot.value && !this.isMobTab) ? "block" : "none"; 
        this.homeService.dashboardView$.next('dayboard');        
      });
  }

  collapseHeader() {
    this.hideHeader = !this.hideHeader;
    this.headerHidden.emit(this.hideHeader);
  }

  openMobileHeader() {
    this.showMobilePanel = !this.showMobilePanel;
    this.mobileHeaderHidden.emit(this.showMobilePanel);
  }

  setClock() {
    this.clockInterval = setInterval(() => {
      this.currentTime = moment().format(DateFormat.HHMMA);
    }, 1000);
  }

  refresh() {
    this.dayBoardDateService.dateChanged$.next(this.currentDate);
    this.dayBoardDateService.toDoCall$.next(this.currentDate);
  }

  changeDefaultAccount(defaultChecked) {
    var userDetail = {
      id: this.user.id,
      customerShipTo: this.selectedAccount.shipTo,
      defaultAccount: !defaultChecked,
    };
    this.accountService
      .updateDefaultAccount(userDetail)
      .subscribe((response) => {
        if (response) {
          this.selectedAccount.isDefault = !defaultChecked;
        }
      });
  }

  loadUserDetails(principal) {
    this.homeService.resetReservations();
    if (principal) {
      this.user = principal;
      this.nuctracEssential = principal.nuctracEssential;
      this.accountList = this.user.departments;
      this.permission=this.storage.retrieve(CacheConstant.SessionStorageData.Permissions);
      this.permission.forEach(permission=>{
        if (permission === AppConstant.Permissions.ManageComponentProcedures || permission === AppConstant.Permissions.Dayboard_read_only_orders) {
          this.disableControl = true;
      }
        });
      this.accountList.sort((a, b) => a.name.localeCompare(b.name));
      this.accountList.forEach((department) => {
        if (department.shipTo == principal.defaultShipTo.id) {
          this.selectedAccount = department;
          this.cache.set(CacheConstant.LocalStorage.SelectedAccount,this.selectedAccount);
          moment.tz.setDefault(this.selectedAccount.timeZoneText);
          this.setDateTime();
          this.dayBoardDateService.dateChanged$.next(this.currentDate);
          this.dayBoardDateService.toDoCall$.next(this.currentDate);
        }
      });
      //5314 changes start
      this.showDeliveryAddress = false;
      this.accountService.getTruckShipTo().subscribe((response) => {
        if (response && response.data.length > 0) {
          this.deliveryAddressList = response.data;
          this.showDeliveryAddress = true;

          const address = this.cache.get(CacheConstant.LocalStorage.DeliveryAddress);
          if (address) {
            this.selectedAddress = address;
            this.isRejectDialogRequest();
          } else {
            this.openDeliveryAddressDialog();
          }
        } else {
          this.showDeliveryAddress = false;
        }
        this.isMobile.emit(this.selectedAccount.isMobile);
        this.showMobile = false;
        if (!this.showDeliveryAddress && this.selectedAccount.isMobile) {
          this.accountService
            .getMobiles(moment(this.currentDate))
            .subscribe((response) => {
            if (response && response.data && response.data.length > 0) {
                this.mobileList = response.data;
                this.showMobile = true;
                this.mobileList.forEach((mobile) => {
                  if (mobile.default) {
                    this.selectedMobile = mobile;
                  }
                });
                const localMobile = this.cache.get(CacheConstant.LocalStorage.Mobile);
                if (localMobile) {
                  this.selectedMobile = localMobile;
                } else {
                this.showMaintenanceBanner();
                }

              } else {
                this.showMobile = false;
                this.isRejectDialogRequest();
              }
            });
        }
      else{
        if(!this.showMobile && !this.showDeliveryAddress && !this.selectedAccount.isMobile){
          this.isRejectDialogRequest();
        }
        this.showMaintenanceBanner();
      }
        //this.homeService.getReservationCount(this.selectedAccount.isMobile);
      });
      //5314 changes end

      const loadReservationFlag = (this.selectedAccount.isMobile && this.showMobile)  || this.showDeliveryAddress;
      this.homeService.getManufacturerOrderCount(loadReservationFlag);
    }
  }


  changeAccount() {

    this.authService.resetCache();
      this.storage.store(
        CacheConstant.SessionStorageData.ShipTo,
        this.selectedAccount.shipTo
      );
      let userDetail = {
        userDetailNum: this.user.id,
        customerShipToNum: this.selectedAccount.shipTo,
        eventType: 'ACCOUNT_CHANGED',
      };
      this.accountService
        .userAccountChange(userDetail)
        .subscribe((response:any) => {
          this.storage.store(CacheConstant.SessionStorageData.AuthenticationToken, 'Bearer ' + response.headers.get('Access-Token'));
          if (this.selectedAccount.syntrac) {
            this.principal.identity(this.selectedAccount.shipTo,true).then((response) => {
              this.loadUserDetails(response);
              this.router.navigate('/home');
            });
          }
          else{
            this.authService.woRedirect(response.headers.get('Access-Token'));
          }
          this.loadPreferences();
        });
  }

  showEODReport() {
    this.dialog
      .open(EodReportComponent, {
        data: {
          dayBoardDate: this.currentDate,
          listOfSelectedShipTo:this.selectedAccount.shipTo
        },
        panelClass: 'eod-report-dialog',
      })

  }
  openRequest() {
    this.dialog
      .open(RejectedRequestComponent, {
        panelClass: 'rejected-request',
      })
      .afterClosed()
      .subscribe((result) => {
        this.getData(this.currentDate);
      });
  }


  openRejectNotificationDialog() {
    this.homeService.openRejectNotificationDialog(this.rejectionNotificationData);
  }

  changeSecurityQuestion() {

    this.principal.getEnvironment('logouturl').subscribe((response:IResponse)=>{
      this.loginUrl=response.data.value;
    });
    let securityQuestionUrl = 'verify-password';
    if (this.loginUrl) {
      let url = this.loginUrl + '/' + securityQuestionUrl + '/' + this.user.emailId + '/';
      window.open(url);
    }

  }

  logOut(logoutMethod:any = 'timeout') {
    this.authService.logOut(logoutMethod);
  }

  changeDate(value) {
    const baseDate = moment(this.dayBoardDate, DateFormat.MMMMDYYYY).toDate();
    this.changedDate = baseDate.setDate(baseDate.getDate() + value);

    this.dayBoardDate = moment(this.changedDate).format(DateFormat.MMMMDYYYY);
    this.currentDate = moment(this.changedDate).format();

    this.showToday = this.checkDate(this.changedDate);
    this.dayBoardDateService.dateChanged$.next(this.changedDate);
    this.dayBoardDateService.toDoCall$.next(this.changedDate);
  }

  dateChange(date: any) {
    let timeOffset= (moment(date).utcOffset() + new Date(date).getTimezoneOffset()) * 60 * 1000;
    this.currentDate = moment(new Date(date.getTime() - timeOffset)).format();
    this.dayBoardDate = moment(new Date(date.getTime() - timeOffset)).format(DateFormat.MMMMDYYYY);
    this.showToday = this.checkDate(this.currentDate);
    this.dayBoardDateService.dateChanged$.next(this.currentDate);
    this.dayBoardDateService.toDoCall$.next(this.currentDate);
  }

  checkDate(date) {
    return moment().format(DateFormat.MMDDYYYY) !== moment(date).format(DateFormat.MMDDYYYY)
  }

  openMobileDialog(): void {
    const dialogRef = this.dialog.open(SelectMobileDialogComponent, {
      width: '500px',
      height: '300px',
      panelClass: 'select-mobile',
      data: { account: this.selectedAccount.name, mobiles: this.mobileList },
      disableClose: true,
      hasBackdrop: true,
      enterAnimationDuration:'0ms',
      exitAnimationDuration:'0ms'
    });

    dialogRef.afterClosed().subscribe((mobile) => {
      this.selectedMobile = mobile;
      this.cache.set(CacheConstant.LocalStorage.Mobile, this.selectedMobile);
      this.isRejectDialogRequest();
      this.loadReservations();    
    });
  }

  searchAccountByShipTo(term: string, item: any) {
    var text = term.toUpperCase();
    return (
      item.shipTo.toString().toUpperCase().indexOf(text) > -1 ||
      item.name.toUpperCase().indexOf(text) > -1
    );
  }

  /*********************Component Methods*********************/

  /*********************Private Methods*********************/

  private getAccountDetails() {
    this.accountList = this.storage.retrieve(
      CacheConstant.SessionStorageData.AllDigiRadDepartments
    );
    this.loggedInUser = this.storage.retrieve(
      CacheConstant.SessionStorageData.LoggedInUser
    );
    this.principal.identity(null,true).then((response) => {
      this.loadUserDetails(response);
      this.user = response;
    });
  }

  openDeliveryAddressDialog(): void {
    const dialogRef = this.dialog.open(SelectAddressDialogComponent, {
      width: '500px',
      height: '300px',
      panelClass: 'select-address',
      data: { account: this.selectedAccount.name, deliveryAddressList: this.deliveryAddressList },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((address) => {
      this.selectedAddress = address;
      this.cache.set(CacheConstant.LocalStorage.DeliveryAddress, this.selectedAddress);
      this.isRejectDialogRequest();
      this.loadReservations();
    });
  }

  loadReservations(): void {
    const isreservLoaded=this.cache.get(CacheConstant.LocalStorage.reservations);    
    if (this.homeService.isReservationsLoaded() && this.manufacturerOrderCount > 0 && !isreservLoaded) {
      if (!this.manufacturerOrderPref) {
        const dialogRef = this.dialog.open(ManufacturerOrderPopupComponent, {
          width: '500px',
          height: '300px',
          panelClass: 'reservations',
          data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
          this.cache.set(CacheConstant.LocalStorage.reservations, true);
          if (result.data) {
            this.router.navigate('/alerts/manufacturer-order-alerts');
          } else {
            this.router.navigate('/home');
          }
        });
      }
    }
  }

  changeAddress(){
    this.cache.set(CacheConstant.LocalStorage.DeliveryAddress, this.selectedAddress);
  }

  isRejectDialogRequest(){
    if(this.showNewRejectNotification && this.rejectedCount > 0){
      this.homeService.openRejectNotificationDialog(this.rejectionNotificationData);
    }
  }

  setDashboardChangedDate(){
     this.subscription.setDayboardDate = this.dayBoardDateService.setDayboardDate$.subscribe(
      (date:Date) => {           
        if(date !==null && date!==undefined){       
          let timeOffset= (moment(date).utcOffset() + new Date(date).getTimezoneOffset()) * 60 * 1000;          
          this.dayBoardDate = moment(new Date(date.getTime() - timeOffset)).format(DateFormat.MMMMDYYYY);
          this.showToday = this.checkDate(this.dayBoardDate);          
        }
    });     
  }
  
  hideDashboardDate(){
    this.subscription.dashboardView = this.homeService.dashboardView$.subscribe((view) => {
      this.type = view;      
      if(this.routerObject.url === '/'+AssayDoseRoutes.AssayDose.Url) {
        this.type = 'assay-dose';
      }       
    });
  }

  /*********************Private Methods*********************/
}
